export default "\n<!-- Modal Body -->\n<div [innerHTML]=content class=\"modal-body\"></div>\n";